document.addEventListener("DOMContentLoaded", function() {
  document.querySelectorAll(".content-hub-faq button").forEach(function(btn) {
    btn.addEventListener("click", function() {
      var isOpen = this.getAttribute("aria-expanded") === "true";
      document.querySelectorAll(".content-hub-faq button").forEach(function(b) {
        b.setAttribute("aria-expanded", "false");
      });
      if (!isOpen) this.setAttribute("aria-expanded", "true");
    });
  });
});
